import React from "react";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";

const Radio = styled.button(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  fontSize: "1.6rem",
  color: theme.color.light_gray,
  lineHeight: "2rem",
  gap: "1rem",
}));

type Props = {
  onClick: () => void;
  active: boolean;
  label?: string;
};
const RadioButton = ({ onClick, active, label }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Radio onClick={onClick} type="button">
      <Image
        src={
          active ? theme.image.radio_on.default : theme.image.radio_off.default
        }
      />
      {label && <span>{t(label)}</span>}
    </Radio>
  );
};

export default RadioButton;
